

class LoadingStates {
    static INITIALIZED = Symbol("INITIALIZED");
    static LOADING = Symbol("LOADING");
    static FINISHED_LOADING = Symbol("FINISHED_LOADING");
    static FAILED_TO_LOAD = Symbol("FAILED_TO_LOAD");
}

export default LoadingStates;
